/**
 * OurTeam Widget
 */
import React , {Component} from 'react';
import Slider from "react-slick";
import { Row, Col, Container } from 'reactstrap';
import {Link} from 'react-router-dom';

function OurTeam(props) {
   const settings = props.settings;
   return (
            <Col sm={12}>
                <div className="ciyashop_team_member_list ciyashop_team_members_style_style-3">
                    <Slider {...settings} className="slider-arrow-hover slider-spacing-10">
                        <div className="item">
                            <div className="team shadow">
                            <div className="team-images">
                                <img className="img-fluid" src={require(`../assets/images/team/Abelle.jpeg`)}  />
                            </div>
                            <div className="team-info">
                                <div className="team-description">
                                <h4>Abelle</h4>
                                <span>Social Media - Facebook Pixel</span>
                                </div>
                                <div className="team-social-icon ciyashop-social-icons ciyashop-social-shape-round ciyashop-social-effect-color-hover ciyashop-social-size-small">
                                <ul>
                                    <li className="ciyashop-social-item ciyashop-social-color-facebook">
                                    <a href="http://www.facebook.com" title="Facebook" target="_blank">
                                        <i className="fa fa-facebook" />
                                    </a>
                                    </li>
                                    <li className="ciyashop-social-item ciyashop-social-color-twitter">
                                    <a href="http://www.twitter.com" title="Twitter" target="_blank">
                                        <i className="fa fa-twitter" />
                                    </a>
                                    </li>
                                    
                                </ul>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div className="item">
                            <div className="team shadow">
                            <div className="team-images">
                                <img className="img-fluid" src={require(`../assets/images/team/harris_2.jpg`)}  />
                            </div>
                            <div className="team-info">
                                <div className="team-description">
                                <h4>Harris</h4>
                                <span>Social Media - Influencer</span>
                                </div>
                                <div className="team-social-icon ciyashop-social-icons ciyashop-social-shape-round ciyashop-social-effect-color-hover ciyashop-social-size-small">
                                <ul>
                                    <li className="ciyashop-social-item ciyashop-social-color-facebook">
                                    <a href="http://www.facebook.com" title="Facebook" target="_blank">
                                        <i className="fa fa-facebook" />
                                    </a>
                                    </li>
                                    <li className="ciyashop-social-item ciyashop-social-color-twitter">
                                    <a href="http://www.twitter.com" title="Twitter" target="_blank">
                                        <i className="fa fa-twitter" />
                                    </a>
                                    </li>
                                    
                                </ul>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div className="item">
                            <div className="team shadow">
                            <div className="team-images">
                                <img className="img-fluid" src={require(`../assets/images/team/Isabel_2.jpeg`)}  />
                            </div>
                            <div className="team-info">
                                <div className="team-description">
                                <h4>Isabel</h4>
                                <span>Product design - Moodboard</span>
                                </div>
                                <div className="team-social-icon ciyashop-social-icons ciyashop-social-shape-round ciyashop-social-effect-color-hover ciyashop-social-size-small">
                                <ul>
                                    <li className="ciyashop-social-item ciyashop-social-color-facebook">
                                    <a href="http://www.facebook.com" title="Facebook">
                                        <i className="fa fa-facebook" />
                                    </a>
                                    </li>
                                    <li className="ciyashop-social-item ciyashop-social-color-twitter">
                                    <a href="http://www.twitter.com" title="Twitter">
                                        <i className="fa fa-twitter" />
                                    </a>
                                    </li>
                                </ul>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div className="item">
                            <div className="team shadow">
                            <div className="team-images">
                                <img className="img-fluid" src={require(`../assets/images/team/nic.jpg`)}  />
                            </div>
                            <div className="team-info">
                                <div className="team-description">
                                <h4>Nicholas</h4>
                                <span>Website Design/ Stack</span>
                                </div>
                                <div className="team-social-icon ciyashop-social-icons ciyashop-social-shape-round ciyashop-social-effect-color-hover ciyashop-social-size-small">
                                <ul>
                                    <li className="ciyashop-social-item ciyashop-social-color-facebook">
                                    <a href="http://www.facebook.com" title="Facebook">
                                        <i className="fa fa-facebook" />
                                    </a>
                                    </li>
                                    <li className="ciyashop-social-item ciyashop-social-color-twitter">
                                    <a href="http://www.twitter.com" title="Twitter">
                                        <i className="fa fa-twitter" />
                                    </a>
                                    </li>
                                </ul>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div className="item">
                            <div className="team shadow">
                            <div className="team-images">
                                <img className="img-fluid" src={require(`../assets/images/team/sheryl.jpg`)}  />
                            </div>
                            <div className="team-info">
                                <div className="team-description">
                                <h4>Sheryl</h4>
                                <span>Google - SEM</span>
                                </div>
                                <div className="team-social-icon ciyashop-social-icons ciyashop-social-shape-round ciyashop-social-effect-color-hover ciyashop-social-size-small">
                                <ul>
                                    <li className="ciyashop-social-item ciyashop-social-color-facebook">
                                    <a href="http://www.facebook.com" title="Facebook">
                                        <i className="fa fa-facebook" />
                                    </a>
                                    </li>
                                    <li className="ciyashop-social-item ciyashop-social-color-twitter">
                                    <a href="http://www.twitter.com" title="Twitter">
                                        <i className="fa fa-twitter" />
                                    </a>
                                    </li>
                                </ul>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div className="item">
                            <div className="team shadow">
                            <div className="team-images">
                                <img className="img-fluid" src={require(`../assets/images/team/JY.jpeg`)}  />
                            </div>
                            <div className="team-info">
                                <div className="team-description">
                                <h4>Jing Ying</h4>
                                <span>Google - SEO</span>
                                </div>
                                <div className="team-social-icon ciyashop-social-icons ciyashop-social-shape-round ciyashop-social-effect-color-hover ciyashop-social-size-small">
                                <ul>
                                    <li className="ciyashop-social-item ciyashop-social-color-facebook">
                                    <a href="http://www.facebook.com" title="Facebook">
                                        <i className="fa fa-facebook" />
                                    </a>
                                    </li>
                                    <li className="ciyashop-social-item ciyashop-social-color-twitter">
                                    <a href="http://www.twitter.com" title="Twitter">
                                        <i className="fa fa-twitter" />
                                    </a>
                                    </li>
                                </ul>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div className="item">
                            <div className="team shadow">
                            <div className="team-images">
                                <img className="img-fluid" src={require(`../assets/images/team/img-07.jpg`)}  />
                            </div>
                            <div className="team-info">
                                <div className="team-description">
                                <h4> Shirwin </h4>
                                <span>Social Media - Marketing</span>
                                </div>
                                <div className="team-social-icon ciyashop-social-icons ciyashop-social-shape-round ciyashop-social-effect-color-hover ciyashop-social-size-small">
                                <ul>
                                    <li className="ciyashop-social-item ciyashop-social-color-facebook">
                                    <a href="http://www.facebook.com" title="Facebook">
                                        <i className="fa fa-facebook" />
                                    </a>
                                    </li>
                                    <li className="ciyashop-social-item ciyashop-social-color-twitter">
                                    <a href="http://www.twitter.com" title="Twitter">
                                        <i className="fa fa-twitter" />
                                    </a>
                                    </li>
                                </ul>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div className="item">
                        <div className="team shadow">
                        <div className="team-images">
                            <img className="img-fluid" src={require(`../assets/images/team/img-08.jpg`)}  />
                        </div>
                        <div className="team-info">
                            <div className="team-description">
                            <h4>Rajnivas</h4>
                            <span>Google - GDN</span>
                            </div>
                            <div className="team-social-icon ciyashop-social-icons ciyashop-social-shape-round ciyashop-social-effect-color-hover ciyashop-social-size-small">
                            <ul>
                                <li className="ciyashop-social-item ciyashop-social-color-facebook">
                                <a href="http://www.facebook.com" title="Facebook">
                                    <i className="fa fa-facebook" />
                                </a>
                                </li>
                                <li className="ciyashop-social-item ciyashop-social-color-twitter">
                                <a href="http://www.twitter.com" title="Twitter">
                                    <i className="fa fa-twitter" />
                                </a>
                                </li>
                                
                            </ul>
                            </div>
                        </div>
                        </div>
                    </div>
                    </Slider>
                </div>
            </Col>
        )

    }

export default OurTeam;
